"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var formatPrice = function formatPrice(price) {
  var sanitisedPrice = Number(price) || 0;
  return sanitisedPrice % 1 !== 0 ? sanitisedPrice.toFixed(2) : sanitisedPrice;
};
var _default = exports["default"] = formatPrice;